import React from 'react';
import { useEntity } from '@backstage/plugin-catalog-react';
import { useApi, configApiRef } from '@backstage/core-plugin-api';
import { InfoCard } from '@backstage/core-components';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import DescriptionIcon from '@material-ui/icons/Description';
import ShowChartIcon from '@material-ui/icons/ShowChart';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';

import { useEnv } from './EnvContext';
import { findApp, urlsForApp } from '../coalitions';

// Env-scoped Observability card. Metrics + Logs deep-links using the
// coalition's tier config.
export const EntitySparrowDeskObservabilityCard = () => {
  const { entity } = useEntity();
  const config = useApi(configApiRef);
  const { coalition, env } = useEnv(entity, config);

  const app = coalition ? findApp(coalition, entity) : undefined;
  if (!coalition || !app || !env) return null;

  const urls = urlsForApp(app, env, coalition);
  if (!urls) return null;

  const entries: Array<{
    icon: React.ReactNode;
    title: string;
    secondary: string;
    url: string;
  }> = [];

  if (urls.metrics) {
    entries.push({
      icon: <ShowChartIcon />,
      title: 'Pod Metrics — Grafana Mimir',
      secondary: `namespace=${urls.namespace}, deployment=${urls.deployment}, cluster=${urls.cluster}`,
      url: urls.metrics,
    });
  }
  if (urls.logs) {
    entries.push({
      icon: <DescriptionIcon />,
      title: 'Full Logs — Grafana Loki',
      secondary: `cluster=${urls.cluster}, namespace=${urls.namespace}`,
      url: urls.logs,
    });
  }

  if (entries.length === 0) return null;

  return (
    <InfoCard title={`Observability — ${env}`}>
      <List dense>
        {entries.map(e => (
          <ListItem
            key={e.title}
            button
            component="a"
            href={e.url}
            target="_blank"
            rel="noopener noreferrer"
          >
            <ListItemIcon>{e.icon}</ListItemIcon>
            <ListItemText primary={e.title} secondary={e.secondary} />
            <OpenInNewIcon fontSize="small" color="action" />
          </ListItem>
        ))}
      </List>
    </InfoCard>
  );
};

export default EntitySparrowDeskObservabilityCard;
